/* eslint-disable eqeqeq */
import React, { Component } from 'react';
import { Flex, MyCampo, Mycard, Transition } from "../ui";
import { Btn } from "./../UI-Components/Btn";
import { css } from "@emotion/core";
import SimpleReactValidator from 'simple-react-validator';
import { serviceApiResponse } from "../ServiciosMaestros/request";
import { api } from "../ServiciosMaestros/apis";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Modal2 } from "../ServiciosMaestros/componentGeneral";
import { DescriptionComponent } from '../Helpers/urlDescription'
import InputProductos from '../UI-Components/InputProductos';

const getTipoMoneda = () => {
    let tipoMoneda = sessionStorage.getItem('configuracion');
    if (tipoMoneda) {
        tipoMoneda = JSON.parse(tipoMoneda)
        tipoMoneda = tipoMoneda.busqueda.find(el => el.campoDb.toLowerCase() == 'total')
        tipoMoneda = tipoMoneda ? tipoMoneda.moneda : 'COP'
    } else {
        tipoMoneda = 'COP'
    }
    return tipoMoneda ? tipoMoneda : 'COP';
}
const validarTopes = (topeGeneral, topeCampo) => {
    let conversion = sessionStorage.getItem('configuracion');
    conversion = JSON.parse(conversion).conversion.value;
    if (getTipoMoneda().toLowerCase() == 'usd') {
        topeGeneral.min = parseFloat(topeGeneral.min / conversion).toFixed(2)
        topeGeneral.max = parseFloat(topeGeneral.max / conversion).toFixed(2)
    }
    let resp = {
        min: topeCampo.min == 0 || !(topeCampo.min) ? topeGeneral.min : topeCampo.min,
        max: topeCampo.max == 0 || !(topeCampo.max) ? topeGeneral.max : topeCampo.max,
    };
    if (!(resp.min >= topeGeneral.min && resp.min <= topeGeneral.max)) {
        resp.min = topeGeneral.min
    }
    if (!(resp.max >= topeGeneral.min && resp.max <= topeGeneral.max)) {
        resp.max = topeGeneral.max
    }
    if (resp.max < resp.min) {
        resp = topeGeneral
    }
    return resp;
}
const Campos = ({ disabled, conf, i, onChange, onChangeRadio, onChangeCheckbox, onChangePrefijo, onChangeValor, error, onChangeDate, handleDateChangeTime, onChangeValor2, updateProductos }) => {

    i = i.toLocaleString();

    if (conf.fieldType === "select") {
        return (
            <div
                className={"f01"}
            >
                <MyCampo
                    select
                    label={conf.name}
                    options={conf.fieldOptions}
                    value={conf.value}
                    name={i}
                    onchange={onChange.bind(this)}
                    obligatory={conf.obligatory}
                    disabled={disabled}
                    error={error}
                    help={conf.help}
                />

            </div>
        )
    }
    else if (conf.fieldType === "password") {
        return (
            <MyCampo
                disabled={disabled}
                type="password"
                label={conf.name}
                placeholder={conf.name}
                value={conf.value}
                configuracionCampos={conf.fieldTypes}
                name={i}
                onchange={onChange.bind(this)}
                obligatory={conf.obligatory}
                error={error}
                help={conf.help}
            />
        )
    }
    else if (conf.fieldType === "text") {
        return (
            <MyCampo
                type="text"
                label={conf.name}
                placeholder={conf.name}
                value={conf.value}
                configuracionCampos={conf.fieldTypes}
                name={i}
                onchange={onChange.bind(this)}
                obligatory={conf.obligatory}
                error={error}
                disabled={disabled}
                help={conf.help}
            />
        )
    }
    else if ((conf.fieldType === "numeric" || conf.fieldType === "number") && conf.fieldDb !== "total" && conf.fieldDb !== "iva") {
        return (
            <MyCampo
                type="tel"
                label={conf.name}
                placeholder={conf.name}
                value={conf.value}
                name={i}
                onchange={onChange.bind(this)}
                obligatory={conf.obligatory}
                configuracionCampos={conf.fieldTypes}
                disabled={disabled}
                help={conf.help}
                error={error}
            />
        )
    } else if (conf.fieldDb === "total" || conf.fieldDb === "iva" || conf.fieldType === "currency") {
        return (
            <MyCampo
                type="mount"
                label={conf.name}
                placeholder={conf.name}
                value={conf.value}
                name={i}
                onChangeValor={conf.fieldDb === "total" ? onChangeValor.bind(this) : (valor) => onChangeValor2(valor, conf)}
                obligatory={conf.obligatory}
                configuracionCampos={conf.fieldTypes}
                disabled={disabled}
                help={conf.help}
                error={error}
                disabledIcon={disabled}
            />
        )
    }
    else if (conf.fieldType === "date") {
        return (
            <MyCampo
                type="date"
                label={conf.name}
                placeholder={conf.name}
                value={conf.value}
                className={`${conf.help && "mr-2"}`}
                name={i}
                onChangeDate={onChangeDate.bind(this)}
                obligatory={conf.obligatory}
                disabled={disabled}
                help={conf.help}
                error={error}
            />
        )
    }
    else if (conf.fieldType === "time") {
        return (
            <MyCampo
                type="time"
                label={conf.name}
                placeholder={conf.name}
                value={conf.value}
                name={i}
                handleDateChangeTime={handleDateChangeTime.bind(this)}
                obligatory={conf.obligatory}
                disabled={disabled}
                help={conf.help}
                error={error}
            />
        )
    }
    else if (conf.fieldType === "radio" || conf.fieldType === "checkbox") {
        return (
            <MyCampo
                type={conf.fieldType}
                label={conf.name}
                placeholder={conf.name}
                value={conf.value}
                options={conf.fieldOptions}
                name={i}
                entity={conf.entity}
                onchange={conf.fieldType === "radio" ? onChangeRadio.bind(this) : onChangeCheckbox.bind(this)}
                obligatory={conf.obligatory}
                help={conf.help}
                disabled={disabled}
                error={error}
            />
        )
    }
    else if (conf.fieldType === "textarea") {
        return (
            <MyCampo
                type="textarea"
                label={conf.name}
                placeholder={conf.name}
                value={conf.value}
                name={i}
                onchange={onChange.bind(this)}
                obligatory={conf.obligatory}
                configuracionCampos={conf.fieldTypes}
                disabled={disabled}
                help={conf.help}
                error={error}
            />
        )
    }
    else if (conf.fieldType === "telephone" || (typeof conf.fieldTypes === 'object' && conf.fieldTypes[0].value === "telephone")) {
        return (
            <MyCampo
                type="telephone"
                label={conf.name}
                placeholder={conf.name}
                value={conf.value}
                valuePrefijo={conf.valuePrefijo ? conf.valuePrefijo : ""}
                name={i}
                onchange={onChange.bind(this)}
                onchangePrefijo={onChangePrefijo.bind(this)}
                obligatory={conf.obligatory}
                disabled={disabled}
                help={conf.help}
                error={error}
            />
        )
    } else if (conf.fieldType === "email") {
        return (
            <MyCampo
                type="email"
                label={conf.name}
                placeholder={conf.name}
                value={conf.value}
                configuracionCampos={conf.fieldTypes}
                name={i}
                onchange={onChange}
                obligatory={conf.obligatory}
                error={error}
                disabled={disabled}
                help={conf.help}
            />
        )
    } else if (conf.fieldType === "productos") {
        return <InputProductos
            inputs={conf.productos}
            label={conf.name}
            help={conf.help}
            updateProductos={updateProductos}
            error={error}
        />
    }
    else {
        return ""
    }
};

let ruta = {};

class InicioFormulario extends Component {


    constructor(props) {
        super(props);
        this.validator = new SimpleReactValidator({
            messages: {
                required: "Campo requerido.",
                between: "El valor mínimo debe ser :min y máximo :max pesos.",
                numeric: "El campo debe ser numérico.",
                min: "El campo debe contener mínimo :min caracteres.",
                max: "El campo debe contener máximo :max caracteres.",
                regex: "Debe ingresar una dirección de correo válida.",
            },
        });
        let confi = JSON.parse(sessionStorage.getItem("configuracion"));
        const campoTotal = confi.busqueda.find(el => el.campoDb == 'total');
        const topes = confi.topes && campoTotal ? validarTopes(confi.topes,
            {
                min: campoTotal.minVal,
                max: campoTotal.maxVal
            }) : {
            "min": 5000,
            "max": 200000
        }
        this.state = {
            configuracion: [],
            titulo: "",
            descripcion: "",
            topes,
            openModal: false,
            productosConfiguracion: false,
            productosSelect: {}
        };
        this.modalRestHorarios = this.modalRestHorarios.bind(this);
    }
    modalRestHorarios() {
        this.setState({ openModal: true })
    }
    componentWillMount() {
        ruta = JSON.parse(sessionStorage.getItem("rutas"));
        if (!this.props.rest_horarios.activo) {
            this.modalRestHorarios();
        }
    }
    componentDidUpdate(prevProps) {
        if (prevProps.rest_horarios.activo !== this.props.rest_horarios.activo) {
            if (!this.props.rest_horarios.activo) {
                this.modalRestHorarios();
            }
        }
    }

    componentDidMount() {

        let fecha = ``;
        if (sessionStorage.getItem("configuracion")) {
            let productosConfiguracion = false;
            let confi = JSON.parse(sessionStorage.getItem("configuracion"));
            let configuracionFormulario = JSON.parse(sessionStorage.getItem("detalleFormulario"));
            let titulo = sessionStorage.getItem("titulo");
            let descripcion = sessionStorage.getItem("descripcion");

            if (configuracionFormulario) {
                const prd = configuracionFormulario.find(el => el.fieldDb == "productos");
                if (prd) {
                    productosConfiguracion = true;
                }
                this.setState({
                    configuracion: configuracionFormulario,
                    titulo,
                    descripcion,
                    productosConfiguracion
                });
            }
            else if (Object.keys(confi).indexOf("busqueda") !== -1) {

                const prd = confi.busqueda.find(el => el.tipoCampo == "productos");
                if (prd) {
                    productosConfiguracion = true;
                }
                let configuracion = confi.busqueda.map((conf) => {

                    return {
                        name: conf.tituloCampo,
                        help: conf.textoAyuda,
                        fieldDb: conf.campoDb,
                        obligatory: conf.obligatorio,
                        fieldType: conf.configCampo,
                        fieldOptions: conf.options,
                        fieldOption: conf.haveOptions,
                        fieldTypes: conf.configCampos,
                        entity: conf.tipoCampo,
                        minVal: conf.minCheck ? conf.minVal : null,
                        maxVal: conf.maxCheck ? conf.maxVal : null,
                        decimal: conf.decimal ? conf.decimal : null,
                        value: conf.configCampo === "time" || conf.configCampo === "date" ? fecha : "",
                        productos: conf.productos
                    };
                });
                const campoTotal = confi.busqueda.find(el => el.campoDb == 'total');
                const topes = confi.topes && campoTotal ? validarTopes(confi.topes,
                    {
                        min: campoTotal.minVal,
                        max: campoTotal.maxVal
                    }) : {
                    "min": 5000,
                    "max": 200000
                }
                this.setState({
                    configuracion,
                    titulo,
                    descripcion,
                    topes,
                    productosConfiguracion
                });

            }
        }
    }

    componentWillReceiveProps(nextProps, nextContext) {

        let fecha = ``;
        let configuracionFormulario = JSON.parse(sessionStorage.getItem("detalleFormulario"));
        let titulo = sessionStorage.getItem("titulo");
        let descripcion = sessionStorage.getItem("descripcion");
        let configuracion = JSON.parse(sessionStorage.getItem("configuracion"));
        const campoTotal = configuracion.busqueda.find(el => el.campoDb == 'total');
        const topes = configuracion.topes && campoTotal ? validarTopes(configuracion.topes,
            {
                min: campoTotal.minVal,
                max: campoTotal.maxVal
            }) : {
            "min": 5000,
            "max": 200000
        }
        if (configuracionFormulario) {
            this.setState({
                configuracion: configuracionFormulario,
                titulo,
                descripcion,
                topes
            });
        }

        else if (Object.keys(nextProps).length > 0 && nextProps.configuracion) {
            let Configuracion = nextProps.configuracion.map((conf) => {
                return {
                    name: conf.tituloCampo,
                    help: conf.textoAyuda,
                    fieldDb: conf.campoDb,
                    obligatory: conf.obligatorio,
                    fieldType: conf.configCampo,
                    fieldOptions: conf.options,
                    fieldOption: conf.configCampo,
                    fieldTypes: conf.configCampos,
                    entity: conf.tipoCampo,
                    value: conf.configCampo === "time" || conf.configCampo === "date" ? fecha : "",
                };
            });
            this.setState({
                Configuracion,
                titulo: nextProps.titulo,
                descripcion: nextProps.descripcion,
                topes: nextProps.topes ? validarTopes(nextProps.topes,
                    {
                        min: campoTotal.minVal,
                        max: campoTotal.maxVal
                    }) : {
                    "min": 5000,
                    "max": 200000
                }
            });

        }
    }

    onChange(e) {

        let { name, value, id } = e.target;
        let configuracion = [...this.state.configuracion];
        let campo = configuracion[parseInt(name)];

        campo.value = value;

        if (id === "telephone") {
            if (value !== "") {
                campo["obligatory"] = true;
                this.forceUpdate();
            }
            else {
                campo["obligatory"] = false;
                this.forceUpdate();
            }
        }

        configuracion[name] = campo;


        this.setState({
            configuracion
        })
    }

    onChangeRadioButton(e) {
        let target = e.target;
        let name = target.name;
        let value = target.value;

        let configuracion = [...this.state.configuracion];
        let campo = configuracion[name];
        campo["value"] = value;
        configuracion[name] = campo;

        this.setState({
            configuracion
        })
    }

    onChangeCheckbox(e) {
        let target = e.target;
        let name = target.name;
        let value = target.value;
        let check = target.checked;
        let configuracion = [...this.state.configuracion];
        let campo = configuracion[name];
        if (campo["value"] !== "") {
            if (check) {
                campo["value"].push(value);
            } else {
                let newCampo = [];
                newCampo = campo["value"].filter((c) => {
                    return c !== value;
                });
                campo["value"] = newCampo.length > 0 ? newCampo : "";
            }
        }
        else {
            campo["value"] = [value];
        }
        configuracion[name] = campo;

        this.setState({
            configuracion
        })
    }

    onChangePrefijo(e) {
        let target = e.target;
        let name = target.name;
        let value = target.value;

        let configuracion = [...this.state.configuracion];
        let campo = configuracion[name];
        campo["valuePrefijo"] = value;
        configuracion[name] = campo;

        this.setState({
            configuracion
        })
    }

    sendInfo() {
        this.setState({
            loading: true
        });
        let configuracion = [...this.state.configuracion];
        let telefono;
        configuracion.map((conf) => {
            if (conf.fieldType === "telephone")
                return telefono = conf.value;
        });
        if (telefono && telefono !== "" && (telefono.length < 8 || telefono.length > 10)) this.validator.fields["telefono"] = false;
        const confi = JSON.parse(sessionStorage.getItem("configuracion"));
        let inputTotal = configuracion.find(val => val.entity == "total");
        const topes = confi.topes && inputTotal ? validarTopes(confi.topes,
            {
                min: inputTotal.minVal,
                max: inputTotal.maxVal
            }) : {
            "min": 5000,
            "max": 200000
        }
        if (inputTotal) {
            let total = Number(inputTotal.value);
            if (topes.max) {
                if (total > topes.max) {
                    toast.warn(`El valor que ingresa es superior al valor máximo ($${topes.max}).`, {
                        hideProgressBar: true
                    })
                    this.setState({
                        loading: false
                    });
                    this.validator.showMessages();
                    this.forceUpdate();
                    return 0;
                }
            }

            if (topes.min) {
                if (total < topes.min) {
                    toast.warn(`El valor que ingresa es inferior al valor mínimo ($${topes.min}).`, {
                        hideProgressBar: true
                    })
                    this.setState({
                        loading: false
                    });
                    this.validator.showMessages();
                    this.forceUpdate();
                    return 0;
                }
            }
        }
        if (this.validator.allValid()) {
            serviceApiResponse({}, api.validarPlan, "POST")
                .then(response => {
                    if (response.success) {
                        sessionStorage.setItem("detalleFormulario", JSON.stringify(this.state.configuracion));
                        this.setState({
                            loading: false
                        });
                        this.props.history.push({
                            pathname: ruta.factura,
                            isSuscrito: this.state.configuracion.isSuscrito || false,
                        });
                    } else {
                        this.setState({
                            loading: false
                        });
                        let informacion = JSON.parse(sessionStorage.getItem("informacion"));
                        this.props.openModal(`El servicio se encuentra temporalmente suspendido, lo invitamos a contactar con la ${informacion.nombreEmpresa} para obtener mayor información al (${informacion.tipoTelefonoValue === "fijo" ? informacion.valueIndicativo : informacion.indicativoPais}) ${informacion.tel_empresa} o correo electrónico ${informacion.correo_empresa}.`, "info");
                    }
                })
                .catch(error => {
                });

        } else {
            this.setState({
                loading: false
            });
            this.validator.showMessages();
            this.forceUpdate();
        }
    }

    validacionCampos(fieldType, fieldTypes, fieldDb, topes) {
        let validacion = ["required"];
        let type = fieldTypes && fieldTypes.length > 0 && fieldTypes.filter((field) => {
            return field.value === fieldType;
        });
        if (fieldDb === "total") {
            validacion += `|between:${topes["min"]},${topes["max"]},num`;
            this.validator.messages = {
                required: "Campo requerido.",
                between: `El valor mínimo debe ser $${topes["min"].toLocaleString(navigator.language, { minimumFractionDigits: 0 })} ${getTipoMoneda()} y máximo $${topes["max"].toLocaleString(navigator.language, { minimumFractionDigits: 0 })} ${getTipoMoneda()}.`,
                numeric: "El campo debe ser numerico",
                min: "El campo debe contener mínimo :min caracteres",
                max: "El campo debe contener máximo :max caracteres",
                regex: "Debe ingresar una dirección de correo válida",
            };
        } else if (fieldDb === "iva") {
            validacion += `|numeric`;
        }
        else if ((fieldType === "text" || fieldType === "number" || fieldType === "textarea") && fieldDb !== "iva") {
            validacion += `|min:2|max:${parseInt(type[0]["longitud"])}`;
        }
        else if (fieldType === "telephone" || fieldDb === "telefono") {
            validacion += `|numeric|min:${parseInt(fieldTypes[0]["min"])}|max:${parseInt(fieldTypes[0]["max"])}`;
        }
        else if (fieldType === "checkbox") {
            validacion += `|array`;
        }
        else if (fieldType === "email") {
            validacion = ['required', { regex: '^(([^<>()\\[\\]\\\\.,;:\\s@"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$' }];
        } else if (fieldDb === "productos") {
            validacion += `|min:1`;
        }
        return validacion;
    }

    onChangeDate(e) {
        let date = new Date(e);
        let fecha = `${date.getFullYear()}-${(date.getMonth() + 1) < 10 ? "0" : ""}${date.getMonth() + 1}-${date.getDate() < 10 ? "0" : ""}${date.getDate()} ${date.getHours() > 9 ? "" : "0"}${date.getHours()}:${date.getMinutes() > 9 ? "" : "0"}${date.getMinutes()}`;
        let configuracion = [...this.state.configuracion];
        let aux = null;
        let campo = configuracion.filter((conf, key) => {
            if (conf.fieldType === "date") {
                aux = key;
                return conf
            }
        });
        campo[0]["value"] = fecha;
        configuracion[aux] = campo[0];
        this.setState({
            configuracion
        })
    }

    handleDateChangeTime(e) {
        let date = new Date(e)
        let hora = `${date.getFullYear()}-${(date.getMonth() + 1) < 10 ? "0" : ""}${date.getMonth() + 1}-${date.getDate() < 10 ? "0" : ""}${date.getDate()} ${date.getHours() > 9 ? "" : "0"}${date.getHours()}:${date.getMinutes() > 9 ? "" : "0"}${date.getMinutes()}`;
        let configuracion = [...this.state.configuracion];
        let aux = null;
        let campo = configuracion.filter((conf, key) => {
            if (conf.fieldType === "time") {
                aux = key;
                return conf
            }
        });
        campo[0]["value"] = hora;
        configuracion[aux] = campo[0];
        this.setState({
            configuracion
        })
    }

    onChangeValor2(valor, config) {
        let configuracion = [...this.state.configuracion];
        let aux = null;
        let campo = configuracion.filter((conf, key) => {
            if (conf.fieldDb === config.fieldDb) {
                if (config.fieldDb == "extras") {
                    if (conf.entity == config.entity) {
                        aux = key;
                        return conf
                    }
                } else {
                    aux = key;
                    return conf
                }
            }
        });
        campo[0]["value"] = valor;
        if (valor !== "") {
            campo[0]["obligatory"] = true;
            this.forceUpdate();
        }
        else {
            campo[0]["obligatory"] = false;
            this.forceUpdate();
        }


        configuracion[aux] = campo[0];
        this.setState({
            configuracion
        })
    }
    updateProductos(productos, total) {
        let configuracion = [...this.state.configuracion];
        let indexTotal = configuracion.findIndex(val => val.entity == "total");
        let indexPrd = configuracion.findIndex(val => val.entity == "productos");
        configuracion[indexTotal].value = total;
        configuracion[indexPrd].value = productos.length === 0 ? "" : JSON.stringify(productos);
        this.setState({
            productosSelect: {
                productos,
                total
            },
            configuracion: configuracion,
            Configuracion: configuracion
        })
    }
    onChangeValor(valor) {
        let configuracion = [...this.state.configuracion];
        let aux = null;
        let campo = configuracion.filter((conf, key) => {
            if (conf.fieldDb === "total") {
                aux = key;
                return conf
            }
        });
        let decimal = false;
        if (campo[0]["decimal"]) {
            decimal = campo[0]["decimal"] != "none" ? true : false
        }

        if (valor) {
            campo[0]["value"] = decimal ? Number(valor.replace(/[^0-9.]+/g, "")) : Number(valor.replace(/[^0-9]+/g, ""));
        }

        configuracion[aux] = campo[0];
        this.setState({
            configuracion
        })
    }

    render() {
        const {
            titulo,
            descripcion,
            configuracion,
            topes
        } = this.state;
        return (
            <Flex
                elastic={"1 0 auto"}
                flex={"1 0 auto"}
                className={"wc cambio"}
                css={css`animation:  ${Transition}  1s cubic-bezier(0.075, 0.820, 0.165, 1.000) 1;`}
            >
                <Mycard
                    className={`col-12 ${configuracion.length > 2 ? " col-sm-12 col-md-10 col-lg-8 " : "col-sm-8 col-md-6 col-lg-4"} mx-auto px-0 `}
                    title={titulo}
                    titleClass="title_consulta"
                >
                    <form
                        className={"wc"}
                        onSubmit={e => {
                            e.preventDefault();
                            if (this.props.rest_horarios.activo) {
                                this.sendInfo();
                            } else {
                                this.modalRestHorarios();
                            }
                        }}
                    >
                        <div className="wc cg text-center description_consulta">
                            <p className={"mb-0 description_consulta"}>{<DescriptionComponent text={descripcion} />}</p>
                        </div>
                        <div className={"wc f01 px-2"}>
                            {configuracion.map((conf, key) =>
                                <div className={`${configuracion.length > 2 ? " col-12 col-md-6" : "col-12"} mb-0 px-0`} key={`formulario-${key}`}>
                                    <Campos
                                        key={key}
                                        conf={conf}
                                        i={key}
                                        onChange={this.onChange.bind(this)}
                                        onChangeRadio={this.onChangeRadioButton.bind(this)}
                                        onChangeCheckbox={this.onChangeCheckbox.bind(this)}
                                        onChangePrefijo={this.onChangePrefijo.bind(this)}
                                        onChangeDate={this.onChangeDate.bind(this)}
                                        onChangeValor={this.onChangeValor.bind(this)}
                                        onChangeValor2={this.onChangeValor2.bind(this)}
                                        updateProductos={this.updateProductos.bind(this)}
                                        campoDb={conf.fieldDb}
                                        handleDateChangeTime={this.handleDateChangeTime.bind(this)}
                                        disabled={this.state.loading || (conf.fieldDb == "total" ? this.state.productosConfiguracion : false)}
                                        error={
                                            (conf.obligatory &&
                                                (this.validator.message(configuracion[key]["entity"], configuracion[key]["value"], this.validacionCampos(typeof conf.fieldType === "string" ? conf.fieldType : conf.fieldType[0].value, conf.fieldTypes, conf.fieldDb, topes)) !== undefined))

                                                ? this.validator.message(configuracion[key]["entity"], configuracion[key]["value"], this.validacionCampos(typeof conf.fieldType === "string" ? conf.fieldType : conf.fieldType[0].value, conf.fieldTypes, conf.fieldDb, topes))
                                                : ""
                                        }
                                    />
                                </div>
                            )}
                        </div>
                        <div className="col-12 pt-3" style={{ lineHeight: 0 }}>
                            <Btn
                                className={"wc"}
                                loading={this.state.loading}
                                type={"submit"}
                            >
                                Continuar
                            </Btn>
                        </div>
                    </form>
                </Mycard>
                <Modal2
                    open={this.state.openModal}
                    close={() => this.setState({ openModal: false })}
                    message={this.props.rest_horarios.message}
                    message2={this.props.rest_horarios.message2}
                    tipo={"info"}
                />
            </Flex>
        )
    }
}

export default InicioFormulario;
